import { useEffect, useState } from 'react';
import { useSelector, useDispatch  } from 'react-redux'
import { updateTask, fetchTask } from '../../../store/slices/tasksReducer'
import { closeModal } from '../../../store/slices/modalReducer'
import { getDefinition } from '../../../store/slices/formsReducer'
import FormWidget from '../../Form/Form';
import { getSessionId } from '../../../api/forms';

function tryParseForm(str) {
   try {
      JSON.parse(str);
   } catch (e) {
      return {};
   }
   return JSON.parse(str);
}
const CancelTask = (props) => {

  const dispatch = useDispatch();
  const { task } = useSelector(state => state.tasks);
  const { formDefinition } = useSelector(state => state.forms);
  const formData = tryParseForm(task.formAndSurveyData?.responseJson);
  const [sessionId, setSessionId]  = useState('');

  useEffect(()=>{
    if(!sessionId) {
      getSessionId()
        .then(sessionIdValue => setSessionId(sessionIdValue))
        .catch((error) => {
          console.error('Error getting session ID:', error);
          // Don't crash if session ID fails - form might still work
        });
    }
  }, [])

  useEffect(() => {
    if(task?.formAndSurveyData?.templateId) dispatch(getDefinition(task?.formAndSurveyData?.templateId));
  }, [dispatch, task]);
  return <>
    { !formDefinition?.template?.content?.name && <div className="row">
      <div className="col-xs-12 u-margin-top u-text-center">
        <span className="a-spinner" role="alert">
          <span className="a-spinner__circle">
            <span className="u-screen-reader-only">Formulier ophalen …</span>
          </span>
        </span>
      </div>
    </div> }
    { !!sessionId && formDefinition?.template?.content?.name && <FormWidget
      // schema = form schema uit de form composer of form api
      schema={formDefinition?.template?.content}
      // form = key/value pairs voor prefilling van formulier (key = field name)
      form={formData}
      session={sessionId}
      // onSubmit = handler voor als formulier gesubmit wordt
      onSubmit={(newformdata) => {
        dispatch(updateTask({
          formAndSurveyData: {
            "responseId": "",
            "responseJson": JSON.stringify(newformdata),
            "templateId": task?.formAndSurveyData?.templateId,
          }
        })).then(() => {
          dispatch(closeModal(false))
          dispatch(fetchTask(task.id));
        });
      }}/> }
  </>

}

export default CancelTask;
